import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { providers } from './app.providers';
import { imports } from './app.imports';

import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';

import { HeaderDropdownComponent } from '@shared/components/header-dropdown/header-dropdown.component';

registerLocaleData(localeNl, 'nl');

@NgModule({
    declarations: [
        AppComponent,
        HeaderDropdownComponent
    ],
    entryComponents: [
        HeaderDropdownComponent
    ],
    imports: imports,
    providers: providers,
    bootstrap: [AppComponent]
})
export class AppModule { }


